import React from 'react';
import { useTranslation } from 'react-i18next';
import { sourceBadgeStyle, sourceLabel } from './addressSourceLabels';

export function AddressProvidersBanner({ status, photonConfigured }) {
    const { t } = useTranslation('school');
    if (status === 'loading') return null;

    if (status === 'unreachable') {
        return (
            <div style={{
                fontSize: 12,
                color: '#92400e',
                marginBottom: 8,
                padding: '8px 10px',
                background: '#fffbeb',
                borderRadius: 8,
                border: '1px solid #fcd34d'
            }}>
                {t('addressSource.unreachable')}
            </div>
        );
    }

    if (status !== 'active') {
        return (
            <div style={{
                fontSize: 12,
                color: '#64748b',
                marginBottom: 8,
                padding: '8px 10px',
                background: '#f8fafc',
                borderRadius: 8,
                border: '1px solid #e2e8f0'
            }}>
                {t('addressSource.inactive')}
            </div>
        );
    }

    return (
        <div style={{
            fontSize: 12,
            color: '#065f46',
            marginBottom: 8,
            padding: '8px 10px',
            background: '#ecfdf5',
            borderRadius: 8,
            border: '1px solid #6ee7b7',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'wrap'
        }}>
            <span style={{ fontWeight: 600 }}>{t('addressSource.active')}</span>
            <span style={{ color: '#047857' }}>
                {t('addressSource.activeHint')}
                {photonConfigured ? t('addressSource.osmMap') : ''}.
            </span>
        </div>
    );
}

export function AddressSourceBadge({ source, compact }) {
    if (!source) return null;
    const label = sourceLabel(source);
    const style = sourceBadgeStyle(source);
    return (
        <span style={{
            display: 'inline-block',
            fontSize: compact ? 10 : 11,
            fontWeight: 600,
            padding: compact ? '2px 6px' : '3px 8px',
            borderRadius: 6,
            marginLeft: compact ? 6 : 0,
            ...style
        }}>
            {label}
        </span>
    );
}

export function StreetHouseLine({ street, houseNumber }) {
    const { t } = useTranslation('school');
    if (!street && !houseNumber) return null;
    const text = street
        ? (houseNumber ? `${street}, ${houseNumber}` : street)
        : houseNumber;
    return (
        <div style={{ fontSize: 12, color: '#334155', marginTop: 4 }}>
            {t('addressSource.streetHouse')} <strong>{text}</strong>
        </div>
    );
}
